import { render, staticRenderFns } from "./RegistrationCompleteModule.vue?vue&type=template&id=be6cf67c&scoped=true&"
import script from "./RegistrationCompleteModule.vue?vue&type=script&lang=js&"
export * from "./RegistrationCompleteModule.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationCompleteModule.vue?vue&type=style&index=0&id=be6cf67c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be6cf67c",
  null
  
)

export default component.exports